import { getBucketData } from 'lib/utilityFunctions';
/*
  Function to support reading same data from different buckets
  Handles cases when user had data in old bucket and new one was released
  also when data esists in both buckets
*/
export default function readBucketData(
  state,
  action,
  objectKey,
  bucketTo,
  isArray = false,
) {
  let mergedData = {};
  const newBucket = (
    getBucketData(
      action.stateData[bucketTo],
    ).gameDetails || {})[objectKey];

  if (newBucket === undefined) {
    mergedData = isArray ? [...state[objectKey]] : { ...state[objectKey] };
  } else {
    // we already switched to new bucket - read data from there
    mergedData = isArray ? [...newBucket] : { ...newBucket };
  }
  return mergedData;
}

export function getQuestsData(currentQuestBucket, questsHistoryBucket, action) {
  // get current quest data or empty object if no data
  const currentQuestData = getBucketData(
    action.stateData[currentQuestBucket],
  ).gameDetails || {};
  // get quests history data or empty object if no data
  const questsHistoryData = getBucketData(
    action.stateData[questsHistoryBucket],
  ).gameDetails || {};
  // placeholder to merge quests data
  const questsData = {};
  questsData.quests = {
    ...questsHistoryData.history,
    ...currentQuestData.currentQuest,
  };
  questsData.contentServiceQuestId = currentQuestData.contentServiceQuestId;
  return questsData;
}
